import { render, staticRenderFns } from "./hotSales.vue?vue&type=template&id=11cef75e&scoped=true&"
import script from "./hotSales.vue?vue&type=script&lang=js&"
export * from "./hotSales.vue?vue&type=script&lang=js&"
import style0 from "./hotSales.vue?vue&type=style&index=0&id=11cef75e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cef75e",
  null
  
)

export default component.exports